import { computed, ref } from 'vue'

const sessionToken = ref<string | null>(null)

const headers = computed(() => {
  if (!sessionToken.value) {
    return undefined
  }
  return { 'x-portal-session': sessionToken.value }
})

export const usePortalToken = () => {
  const setSessionToken = (token: string) => {
    sessionToken.value = token
  }

  const clearSession = () => {
    sessionToken.value = null
  }

  const hasSession = () => sessionToken.value != null

  return { headers, setSessionToken, clearSession, hasSession }
}
